import "./src/styles/global.css";

// my previous gatsby site registered service worker that override my current website, unregister all service workers
navigator.serviceWorker.getRegistrations().then((registrations) => {
  for (const registration of registrations) {
    registration.unregister();
    console.log("service worker unregistered");
  }
});
